/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MediaListApiResponse,
    MediaListApiResponseFromJSON,
    MediaListApiResponseFromJSONTyped,
    MediaListApiResponseToJSON,
} from './MediaListApiResponse';
import {
    PrtimesMediaListsNewMediaOutletsResponseAllOf,
    PrtimesMediaListsNewMediaOutletsResponseAllOfFromJSON,
    PrtimesMediaListsNewMediaOutletsResponseAllOfFromJSONTyped,
    PrtimesMediaListsNewMediaOutletsResponseAllOfToJSON,
} from './PrtimesMediaListsNewMediaOutletsResponseAllOf';

/**
 * response of GET /prtimes_media_lists/new_media_outlets
 * @export
 * @interface PrtimesMediaListsNewMediaOutletsResponse
 */
export interface PrtimesMediaListsNewMediaOutletsResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof PrtimesMediaListsNewMediaOutletsResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof PrtimesMediaListsNewMediaOutletsResponse
     */
    message: string;
    /**
     * 新着メディアの名前リスト（メディア名の重複については排除しています）
     * @type {Array<string>}
     * @memberof PrtimesMediaListsNewMediaOutletsResponse
     */
    mediaNames: Array<string>;
}

export function PrtimesMediaListsNewMediaOutletsResponseFromJSON(json: any): PrtimesMediaListsNewMediaOutletsResponse {
    return PrtimesMediaListsNewMediaOutletsResponseFromJSONTyped(json, false);
}

export function PrtimesMediaListsNewMediaOutletsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrtimesMediaListsNewMediaOutletsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'mediaNames': json['media_names'],
    };
}

export function PrtimesMediaListsNewMediaOutletsResponseToJSON(value?: PrtimesMediaListsNewMediaOutletsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'media_names': value.mediaNames,
    };
}

